import React from 'react'
import Message from 'antd/lib/message'

import 'antd/lib/icon/style/css'
import 'antd/lib/message/style/css'

import './MessageComponent.scss'

class MessageComponent extends React.Component {
  static show(type, ...args) {
    return Message[type](...args)
  }

  componentDidMount() {
    const container = this.elmContainer

    Message.config({
      getContainer: () => container,
      duration: 3,
    })
  }

  render() {
    return (
      <div
        ref={(c) => {
          this.elmContainer = c
        }}
        className="message-component antd-component"
      />
    )
  }
}

MessageComponent.loading = Message.loading

export default MessageComponent
